(function () {
  if (window.veyreProductSwitcherLoaded) return;
  window.veyreProductSwitcherLoaded = true;

  const initProductMediaMotion = (root = document) => {
    root.querySelectorAll('.veyre-product-shell .product__media-wrapper').forEach((wrapper) => {
      if (wrapper.dataset.veyreMotionReady === 'true') return;
      wrapper.dataset.veyreMotionReady = 'true';

      const updateMotion = (event) => {
        const rect = wrapper.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        wrapper.style.setProperty('--veyre-media-x', x.toFixed(3));
        wrapper.style.setProperty('--veyre-media-y', y.toFixed(3));
      };

      const resetMotion = () => {
        wrapper.style.setProperty('--veyre-media-x', '0');
        wrapper.style.setProperty('--veyre-media-y', '0');
      };

      wrapper.addEventListener('pointermove', updateMotion);
      wrapper.addEventListener('pointerleave', resetMotion);
      resetMotion();
    });
  };

  const getSectionUrl = (href, sectionId) => {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  const setLoadingState = (section, link, isLoading) => {
    section.classList.toggle('is-switching-product', isLoading);
    section.querySelectorAll('[data-product-switch]').forEach((item) => {
      item.toggleAttribute('aria-disabled', isLoading);
    });
    if (link) {
      link.classList.toggle('is-loading', isLoading);
    }
  };

  const refreshShopifyControls = () => {
    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    if (window.ProductModel) {
      window.ProductModel.loadShopifyXR();
    }
  };

  const animateMediaIn = (section) => {
    section.classList.remove('is-veyre-media-entering');
    window.requestAnimationFrame(() => {
      section.classList.add('is-veyre-media-entering');
      window.setTimeout(() => {
        section.classList.remove('is-veyre-media-entering');
      }, 760);
    });
  };

  const syncMediaDots = (gallery, target) => {
    gallery.querySelectorAll('[data-veyre-media-dot]').forEach((dot) => {
      const isActive = dot.dataset.target === target;
      dot.classList.toggle('is-active', isActive);
      dot.toggleAttribute('aria-current', isActive);
    });
  };

  const activateGalleryTarget = (control) => {
    const gallery = control.closest('media-gallery');
    const section = control.closest('[data-veyre-product-section]');
    const target = control.dataset.target;

    if (!gallery || !target) return;

    const thumbnail = gallery.querySelector(
      `.thumbnail-list__item[data-target="${target}"] .thumbnail`
    );

    if (!thumbnail) return;

    if (section) {
      animateMediaIn(section);
    }

    thumbnail.click();
    syncMediaDots(gallery, target);
  };

  const moveGalleryTarget = (button) => {
    const gallery = button.closest('media-gallery');
    if (!gallery) return;

    const dots = Array.from(gallery.querySelectorAll('[data-veyre-media-dot]'));
    if (!dots.length) return;

    const activeIndex = Math.max(
      0,
      dots.findIndex((dot) => dot.classList.contains('is-active'))
    );

    const direction = button.dataset.veyreMediaArrow === 'previous' ? -1 : 1;
    const nextIndex = (activeIndex + direction + dots.length) % dots.length;
    activateGalleryTarget(dots[nextIndex]);
  };

  const switchProduct = async (link) => {
    const section = link.closest('[data-veyre-product-section]');

    if (
      !section ||
      link.classList.contains('is-active') ||
      section.classList.contains('is-switching-product')
    ) {
      return;
    }

    const sectionId = section.dataset.section;
    const href = link.getAttribute('href');

    if (!sectionId || !href) return;

    setLoadingState(section, link, true);
    animateMediaIn(section);

    try {
      const response = await fetch(getSectionUrl(href, sectionId), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) {
        throw new Error(`Section request failed: ${response.status}`);
      }

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const nextSection =
        html.querySelector(`[data-veyre-product-section][data-section="${sectionId}"]`) ||
        html.getElementById(`MainProduct-${sectionId}`);

      if (!nextSection) {
        throw new Error('Product section was not found in the response.');
      }

      section.replaceWith(nextSection);

      /* Update URL without page reload */
      window.history.pushState(
        {
          productUrl: href,
          sectionId: sectionId
        },
        '',
        href
      );

      /* Reinitialize Shopify components */
      refreshShopifyControls();
      initProductMediaMotion(nextSection);
      animateMediaIn(nextSection);

      /* Reinitialize third-party apps */
      setTimeout(() => {

        document.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            detail: {
              sectionId: sectionId
            }
          })
        );

        window.dispatchEvent(
          new Event('resize')
        );

      }, 300);

      /* Notify custom gallery */
      requestAnimationFrame(() => {
        document.dispatchEvent(
          new CustomEvent('veyre:product:switched', {
            detail: {
              sectionId: sectionId
            }
          })
        );
      });
      /*
        ── Signal the gallery to re-initialise ──────────────────────────────
        The new section's inline <script> will run and listen for this event.
        We dispatch it slightly after replaceWith so the new DOM is fully
        attached and the script tag has had a chance to execute.
      */
      requestAnimationFrame(() => {
        document.dispatchEvent(
          new CustomEvent('veyre:product:switched', {
            detail: { sectionId },
          })
        );
      });

      nextSection
        .querySelector('[data-product-switch].is-active')
        ?.focus({ preventScroll: true });

    } catch (error) {
      console.error(error);
      setLoadingState(section, link, false);
    }
  };

  /* PRODUCT SWITCHING — CLICK ONLY */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-switch]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    switchProduct(link);
  });

  /* THUMBNAIL CLICK */
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest(
      '.veyre-product-shell .thumbnail:not([aria-current])'
    );
    if (!thumbnail) return;

    const section = thumbnail.closest('[data-veyre-product-section]');
    if (section) animateMediaIn(section);

    const item = thumbnail.closest('[data-target]');
    const gallery = thumbnail.closest('media-gallery');
    if (item && gallery) syncMediaDots(gallery, item.dataset.target);
  });

  /* DOT CLICK */
  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-veyre-media-dot]');
    if (!dot) return;
    event.preventDefault();
    activateGalleryTarget(dot);
  });

  /* ARROW CLICK */
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-veyre-media-arrow]');
    if (!arrow) return;
    event.preventDefault();
    moveGalleryTarget(arrow);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductMediaMotion(), { once: true });
  } else {
    initProductMediaMotion();
  }
})();